import { useLocation } from 'react-router-dom';
import { useJspVariables, useNavigation, useAppContext } from '../hooks';
import PageContainer from './PageContainer';
import PageHeader from './PageHeader';
import { IceIcon } from './Spacer';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const PageMessage = () => {
    const location = useLocation();
    const { jspVariables, launcher, panelStyle } = useJspVariables();
    const { toPageLogin } = useNavigation({ launcher });
    const { getLabelFromJspVariables } = useAppContext(jspVariables);

    const msg = location?.state?.msg || '';
    const heading = location?.state?.heading || '';
    const redirectUrl = location?.state?.redirectUrl || '';

    const backToApplicationEnabled = jspVariables.jspBackToApplicationEnabled !== 'N';

    const gotoApp = () => {
        if (launcher) {
            toPageLogin();
            return;
        }
        window.location.href = redirectUrl;
    };

    return (
        <PageContainer id="pageMessage">
            <div style={panelStyle}>
                <IceIcon launcher={launcher} />
                <PageHeader dataAutomationId="page_message_header">{heading}</PageHeader>
                <div><p>{msg}</p></div>
                {redirectUrl && backToApplicationEnabled &&
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant="contained" fullWidth
                            onClick={gotoApp}
                            data-automation-id="page_message_return_to_app_btn">
                            {getLabelFromJspVariables('action_return_to_application')}
                        </Button>
                    </Box>
                }
            </div>
        </PageContainer>
    );
};

export default PageMessage;
